import { render } from "./CopilotChatViewer.vue?vue&type=template&id=62f6f311&ts=true"
import script from "./CopilotChatViewer.vue?vue&type=script&lang=ts"
export * from "./CopilotChatViewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__